import {ERASER_RADIUS,normalizeEraserRadius} from './eraser-radius.js';
import './eraser-size-control.css';

export default function EraserSizeControl({value,onChange,compact=false}) {
 const radius=normalizeEraserRadius(value);
 return <label className="eraser-size-control" data-eraser-size="true" data-compact={compact} onPointerDown={event=>event.stopPropagation()}>
  <span className="eraser-size-label">擦除粗细</span>
  <input type="range" aria-label="擦除粗细" min={ERASER_RADIUS.min} max={ERASER_RADIUS.max} step={ERASER_RADIUS.step} value={radius} onChange={event=>onChange(Number(event.target.value))}/>
  <span className="eraser-size-preview" aria-hidden="true"><i data-eraser-preview="true" data-size={radius} style={{width:`${radius*2}px`,height:`${radius*2}px`}}/></span>
  <output data-eraser-value="true">{radius}</output>
 </label>;
}
